<template>
  <div v-if="writer" id="WriterInfo" class="wrap">

    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
        <v-toolbar-title class="light-blue--text text--darken-3 ">{{writer.writer_name}} {{writer.writer_title}}  </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn  @click="showEditWriter(writer.id)" icon small  ><v-icon   >mdi-pencil</v-icon></v-btn>
        <RemoveEvaluationWriter :writer="writer"/>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 ">
        <div @click="backDesktop" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <v-container px-0 pt-0 pb-5 >
             <v-layout class="mb-3 mt-10 px-1 hidden-sm-and-down ">
                <v-toolbar-title class=" ">{{writer.writer_name}} {{writer.writer_title}}  </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn  @click="showEditWriter(writer.id)" icon small  ><v-icon   >mdi-pencil</v-icon></v-btn>
          <RemoveEvaluationWriter :writer="writer"/>
             </v-layout>
        <!-- Evaluation Status -->
          <v-card  class="mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">

            <v-card-title @click="showEditEvaluation" class="pa-0">

                <v-layout class="grey lighten-3" align-center>
                  <v-layout  class="grey lighten-3" py-2>
                    <p class="subtitle-1 text--primary ml-2 mb-0 font-weight-light">Evaluation Status</p>
                  </v-layout>

                  <v-spacer></v-spacer>

                      <v-icon class="mr-2">mdi-pencil</v-icon>


                </v-layout>
            </v-card-title>
            <v-card-text class="pb-0 pt-2 pl-0 ">
              <v-layout justify-center >
              <span class="title"><span  :class="{ 'red--text' : writer.evaluation_status === 'Not Yet Requested', 'amber--text text--darken-3' : writer.evaluation_status === 'Agreed to write evaluation', 'blue--text text--lighten-1' : writer.evaluation_status === 'Submitted to CASPA', 'green--text' : writer.evaluation_status === 'Received' }">{{writer.evaluation_status}}</span></span>
              </v-layout>
            </v-card-text>
          </v-card>

        <!-- Contact Information -->
          <v-card  class=" mt-4 mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">
            <v-card-title @click="showEditEvaluation" class="pa-0">
                <v-layout class="grey lighten-3" align-center>
                  <v-layout  class="grey lighten-3" py-2>
                    <p class="subtitle-1 text--primary ml-2 mb-0 font-weight-light">Contact Information</p>
                  </v-layout>


                </v-layout>

            </v-card-title>
            <v-card-text class="pb-0 pt-2 pl-0 ">
              <v-list v-if="writer.writer_phone || writer.writer_email">

              <a :href="`tel:${writer.writer_phone}`">
                <v-list-item  >
                  <v-list-item-action>
                    <v-icon color="light-blue darken-3">mdi-phone</v-icon>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title class="ml-1 light-blue--text text--darken-3">{{writer.writer_phone}}</v-list-item-title>
                  </v-list-item-content>

                </v-list-item >
              </a>
            <v-divider class="my-2 mx-3"></v-divider>

            <a :href="`mailto:${writer.writer_email}`">
            <v-list-item >
              <v-list-item-action>
                <v-icon color="light-blue darken-3">mdi-email</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title class="ml-1 light-blue--text text--darken-3">{{writer.writer_email}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            </a>
          </v-list>
          <v-layout v-else justify-center class="py-1">
            <span class=""> Not Listed</span>
          </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </div>



    <!-- Update Evaluation Status Dialog -->
    <v-dialog
      v-model="editEvaluationStatusDialog"
      style="zIndex:40001"
      max-width="400"
      persistent
      >
      <v-card style="borderRadius:5px">
        <v-card-title class="subheading grey lighten-2 text-xs-center">Update Evaluation Status</v-card-title>
        <v-card-text class="text-xs-justify mt-3 pb-0"  >
        <v-flex xs12>
          <v-select
            outlined
            :items="['Not Yet Requested', 'Agreed to write evaluation','Submitted to CASPA', 'Received']"
            v-model="writer.evaluation_status"
            >
          </v-select>
        </v-flex>
        </v-card-text>
        <v-card-actions>



          <v-btn
            color="green"
            block
            dark
            class="elevation-0"
            @click="saveStatus(writer)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>



</template>

<script>
export default {
  data() {
    return {
      show: false,
      modal: false,
      alert: false,
      date2: "",
      drawer: false,
      menu2: false,
      editStatus: true,
      editEvaluationStatusDialog: false,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
     backDesktop () {
        this.$router.push('/dashboard')
      },
    showEditWriter (writer) {
      this.$router.push('/dashboard/evaluations/editevaluationwriter/' + writer)
    },
    changeStatus () {
      this.editStatus = false
    },
    showEditEvaluation() {
      this.editEvaluationStatusDialog = true
    },
    saveStatus (writer) {
      const writerData = {
        id : this.id,
        evaluation_status : writer.evaluation_status
      }

      this.$store.dispatch('setUpdateEvaluationStatus', writerData)
      this.editEvaluationStatusDialog = false
    }

  },
  computed: {
    id () {
      return this.$route.params.id
    },
    user() {
      return this.$store.getters.user;
    },
    userpaShadows() {
      return this.$store.getters.userpaShadows;
    },
    writer() {
      return this.$store.getters.writerInfo(this.id);
    },
  }
};
</script>

<style scoped>

#schoolToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;

}
.closeButton {
  bottom: 0;
  top: 695px;
  background-color: white;
}

.calendar {
  border-radius: 5px;
}

#header {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }

 .card--flex-toolbar {
    margin-top: -64px;
  }
  a {
    text-decoration: none;
  }
@media (min-width: 960px) {
  .desktopHeader {
    width: calc(100% - 256px);
    margin-left: 256px;
  }
}
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Evaluations/WriterInfo.vue